import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Header from "./components/Header/Header";
import Routers from "./routes/Routers";
import Footer from "./components/Footer/Footer";
import Logo from "./components/Assets/logo2.png";
import { AuthContextProvider } from "./context/AuthContext";

function App() {
  return (
    <div className="app">
      <AuthContextProvider>
        <Header logo={Logo} />
        <main>
          <Routers />
        </main>
        <Footer />
      </AuthContextProvider>
    </div>
  );
}

export default App;
